import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Supplier, Suppliers } from '../Suppliers';
import type { IFair } from './Fairs.types';

@Identifiable
@Timestampable
@Untrackable
export class Fair extends AbstractDocument<IFair> {
  readonly collections = {};

  readonly translatable = (data: IFair): NonNullable<IFair['_translations']>[string] => ({
    description: data.description,
    name: data.name,
  });
}

export class Fairs extends AbstractCollection<Fair, IFair> {
  static path = 'fairs';

  constructor(document: Supplier) {
    super(document.collection(Fairs.path), Fair);
  }

  get supplier() {
    return Suppliers._.getById(this.reference.parent!.id);
  }
}
